import { render } from "./ChartsUnitConfiger.vue?vue&type=template&id=0fbaba4c&scoped=true"
import script from "./ChartsUnitConfiger.vue?vue&type=script&lang=js"
export * from "./ChartsUnitConfiger.vue?vue&type=script&lang=js"

import "./ChartsUnitConfiger.vue?vue&type=style&index=0&id=0fbaba4c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbaba4c"]])

export default __exports__